<script lang="ts">
  import { type Image, usageDomains } from "bildebanken-model";
  import type { EditImageActor, EditImageState } from "./editImageMachine";
  import { updateField } from "./editImageMachine";

  export let service: EditImageActor;
  export let image: Image;

  let selectedUsageDomain =
    (image.metadata.usageDomain && image.metadata.usageDomain[0]) ||
    "http://authority.nrk.no/datadictionary/editorialImage";

  function onChangeUsageDomain(this: HTMLInputElement) {
    updateField(service, "usageDomain", [this.value]);
    if (this.value === "http://authority.nrk.no/datadictionary/promotionalImage") {
      updateField(service, "rightsMarker", "Restricted");
    }
  }
</script>

<fieldset class="org-fieldset">
  <legend>Bruksområde</legend>
  {#each usageDomains as usageDomain}
    <label class="org-button">
      <input
        bind:group={selectedUsageDomain}
        type="radio"
        name="single-demo"
        value={usageDomain.value}
        on:change={onChangeUsageDomain}
      />
      {usageDomain.name}
    </label>
  {/each}
</fieldset>

<style>
  fieldset {
    margin-bottom: var(--org-medium);
  }
</style>
